<template>
  <div class="recharge-record-container">
    <van-nav-bar :title="$t('withdrawal_record')">
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <van-tabs
      :ellipsis="false"
      v-model="active"
      line-height="4px"
      title-active-color="#0062f8"
      background="#f7f9fb"
      color="#0062f8"
      animated
      @click="onClick"
    >
      <van-tab :title="$t('all')">
        <WithdrawRecordList :orderList="orderList" />
      </van-tab>
      <van-tab :title="$t('withdrawal_under_review')">
        <WithdrawRecordList :orderList="orderList" />
      </van-tab>
      <van-tab :title="$t('withdrawal_success')">
        <WithdrawRecordList :orderList="orderList"
      /></van-tab>
      <van-tab :title="$t('fail')">
        <WithdrawRecordList :orderList="orderList"
      /></van-tab>
    </van-tabs>
  </div>
</template>

<script>
import WithdrawRecordList from "@/components/WithdrawRecordList";

export default {
  components: {
    WithdrawRecordList,
  },
  data() {
    return {
      active: 0,
      lastPage: 1,
      page: 1,
      orderList: [],
      isLoading: false,
    };
  },
  created() {
    this.getWithdrawOrder();
  },
  mounted() {
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.getWithdrawOrder();
      }, 1000);
    },
    onClick(e) {
      this.active = e;
      this.page = 1;
      this.getWithdrawOrder();
    },
    async scroll() {
      let scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.page < this.lastPage) {
        if (scrollHeight - scroll <= 820) {
          this.page++;
          this.getWithdrawOrder();
        }
      }
    },
    navBack() {
      if (
        this.$router.history._startLocation.indexOf(this.$route.path) != -1 ||
        this.$router.history._startLocation.indexOf("/withdraw-detail") != -1
      ) {
        this.$router.replace("/withdraw");
      } else {
        this.$router.go(-1);
      }
    },
    async getWithdrawOrder() {
      const res = await this.$api.getWithdrawOrder({
        page: this.page,
        status: this.active,
      });
      if (res.code == 200) {
        this.lastPage = res.data.last_page;
        if (this.page == 1) {
          this.orderList = res.data.data;
        } else {
          this.orderList.push(...res.data.data);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
@media (min-width: 640px) {
  .back {
    width: 30px;
    height: 15px;
  }
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    left: unset;
  }
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  /deep/ .van-tabs__wrap {
    height: 50px;
  }
}
</style>